import React from 'react';
import './Home.scss';
import hitSnag from '../../images/blankpage-images/hitasnag.svg';
import LoginVideo from '../../Videos/gate.mp4';

const BlankPage = () => {
  return (
    <div className='main-container'>
        <div className="inner-main-api-home">
            <div className="content-section-api">
              <div className="left-conent-section">
                <div className="inner-left-part">
                  <div className="top-heading-part-api">
                    <h2>Oops! You’ve hit the backend. No worries we got your back!</h2>
                  </div>
                  <div className="two-buttons-api-blk">
                    <div className="left-button-api">
                      <a href="">
                        <button type="button">
                          <div className="top-button-logo-api">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 174 200" fill="none">
                              <path d="M157.688 58.9623L173.211 49.997L86.6054 0L0 49.997V150.003L86.6054 200L173.211 150.003V97.0175L86.6054 47.0205L40.7234 73.5132V82.5971L103.943 119.099V124.921L86.6054 135.061L40.7234 108.568V126.487L86.6054 152.98L132.487 126.487V117.403L64.1091 77.9247L86.6054 64.9392L157.688 105.971V141.038L86.6054 182.069L15.5233 141.038V58.9623L86.6054 17.9306L157.688 58.9623Z" fill="#fff"/>
                            </svg>
                            <h2 className=''>SG CODES</h2>
                          </div>
                          <div className="bottom-goto-home-sec">
                            <p>Go to home</p>
                            <i className="bi bi-arrow-right-circle"></i>
                          </div>
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="right-image-section">
                  <video src={LoginVideo} autoPlay muted loop controls={false} width="100%"  height="100%"></video>
              </div>
            </div>
        </div>
    </div>
  )
}

export default BlankPage